<template>
    <div class="outer">
        <template v-if="canCreate || canApprove">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="采购单列表" name="1" v-if="canCreate">
                    <GoodsPurchaseList v-if="activeName === '1'"/>
                </el-tab-pane>
                <el-tab-pane label="采购单审批" name="2" v-if="canApprove">
                    <GoodsAdministrativeApproval v-if="activeName === '2'"/>
                </el-tab-pane>
            </el-tabs>
        </template>
        <el-empty v-else style="margin-top: 80px;" description="您没有采购模块的操作权限，如有疑问请联系行政/财务部门"></el-empty>
    </div>
</template>
<script>

import GoodsAdministrativeApproval from './components/GoodsAdministrativeApproval.vue';
import GoodsPurchaseList from './components/GoodsPurchaseList.vue';
import { canCreatePurchase, canApprovePurchase } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            activeName: '1',
            canCreate: canCreatePurchase(), // 采购单发起权限（行政 48/31）
            canApprove: canApprovePurchase(), // 采购单审批权限（财务 27/总经理 8/行政总监 48 复核）
        }
    },
    created() {
        this.activeName = this.canCreate ? '1' : '2';
    },
    components: {
        GoodsAdministrativeApproval,
        GoodsPurchaseList
    },
    computed: {
    },
}
</script>

<style lang="scss" scoped>
</style>
